import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueScrollTo from 'vue-scrollto'
import VueWaypoint from 'vue-waypoint'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueAnimateOnScroll from 'vue-animate-onscroll'

import App from './App.vue'
import router from './router'
import store from './store'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueScrollTo)
Vue.use(VueWaypoint)
Vue.use(VueAnimateOnScroll)

Vue.component('FAIcon', FontAwesomeIcon)

Vue.config.productionTip = false

import 'animate.css/animate.min.css'

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
